const NAV_DATA = [{
        title: '用户管理',
        route: 'users',
        name: 'users',
        children: [{
                title: '查询用户',
                route: 'list',
                name: 'usersList'
            },
            {
                title: '添加用户',
                route: 'add',
                name: 'usersAdd'
            }
        ]
    },
    {
        title: '权限管理',
        route: 'permissions',
        name: 'permissions',
        children: [{
                title: '查询权限',
                route: 'list',
                name: 'permissionsList'
            },
            {
                title: '添加权限',
                route: 'add',
                name: 'permissionsAdd'
            }
        ]
    },
    {
        title: 'HTML5项目',
        route: 'h5',
        name: 'h5',
        children: [{
                title: '查询项目',
                route: 'list',
                name: 'h5List'
            },
            {
                title: '添加项目',
                route: 'add',
                name: 'h5Add'
            },
            {
                title: '导出数据',
                route: 'data',
                name: 'h5Data'
            }
        ]
    },
    {
        title: '商业专题',
        route: 'business',
        name: 'business',
        children: [{
                title: '查询专题',
                route: 'list',
                name: 'businessList'
            },
            {
                title: '添加专题',
                route: 'add',
                name: 'businessAdd'
            },
            {
                title: '编辑新闻',
                route: 'edit',
                name: 'businessEdit'
            },
            {
                title: '添加新闻',
                route: 'news',
                name: 'businessNews'
            },
            {
                title: '添加广告',
                route: 'ad',
                name: 'businessAd'
            },
            {
                title: '组件管理',
                route: 'template',
                name: 'businessTemplate'
            }
        ]
    },
    {
        title: '市场专题',
        route: 'market',
        name: 'market',
        children: [{
                title: '查询专题',
                route: 'list',
                name: 'marketList'
            },
            {
                title: '添加专题',
                route: 'add',
                name: 'marketAdd'
            },
            {
                title: '编辑新闻',
                route: 'edit',
                name: 'marketEdit'
            },
            {
                title: '添加新闻',
                route: 'news',
                name: 'marketNews'
            },
            {
                title: '模块管理',
                route: 'module',
                name: 'marketModule'
            },
            {
                title: '组件管理',
                route: 'template',
                name: 'marketTemplate'
            }
        ]
    },
    {
        title: 'KV直播',
        route: 'kvlive',
        name: 'kvlive',
        children: [{
                title: '查询直播',
                route: 'list',
                name: 'kvliveList'
            },
            {
                title: '添加直播',
                route: 'add',
                name: 'kvliveAdd'
            },
            {
                title: '评论管理',
                route: 'comment',
                name: 'kvliveComment'
            },
        ]
    },
    {
        title: '互动直播',
        route: 'ugclive',
        name: 'ugclive',
        children: [{
                title: '查询直播',
                route: 'list',
                name: 'ugcliveList'
            },
            {
                title: '添加直播',
                route: 'add',
                name: 'ugcliveAdd'
            },
            {
                title: '评论管理',
                route: 'comment',
                name: 'ugcliveComment'
            },
            {
                title: 'PUSH管理',
                route: 'push',
                name: 'ugclivePush'
            }
        ]
    },
    {
        title: '爬虫管理',
        route: 'crawler',
        name: 'crawler',
        children: [{
            title: '商业专题',
            route: 'business',
            name: 'crawlerBusiness'
        }, {
            title: '市场专题',
            route: 'market',
            name: 'crawlerMarket'
        }]
    },
    {
        title: '话题PK',
        route: 'topic',
        name: 'topic',
        children: [{
            title: '查询话题',
            route: 'list',
            name: 'topicList'
        }, {
            title: '创建话题',
            route: 'add',
            name: 'topicAdd'
        }, {
            title: '评论审核',
            route: 'comment',
            name: 'topicCommit'
        }, {
            title: '商业评论',
            route: 'business',
            name: 'topicBusiness'
        }]
    }, {
        title: '投票',
        route: 'vote',
        name: 'vote',
        children: [{
            title: '查询项目',
            route: 'list',
            name: 'voteList'
        }, {
            title: '创建项目',
            route: 'add',
            name: 'voteAdd'
        }, {
            title: '编辑模板',
            route: 'comment',
            name: 'voteEdit'
        }]
    }, {
        title: '一点彩票',
        route: 'lottery',
        name: 'lottery',
        children: [{
            title: '彩票交易数据',
            route: 'deal',
            name: 'dealData'
        }, {
            title: '链接生成器',
            route: 'link',
            name: 'linkGenerate'
        }]
    }, {
        title: '天天赢球',
        route: 'ttyq',
        name: 'ttyq',
        children: [{
            title: '链接生成器',
            route: 'link',
            name: 'ttyqLinkGenerate'
        }]
    }, {
        title: '销售业绩榜单',
        route: 'sell',
        name: 'sell',
        children: [{
            title: '直客销售榜单',
            route: 'zhikeSeller',
            name: 'zhikeSeller'
        }, {
            title: '渠道销售榜单',
            route: 'qudaoSeller',
            name: 'qudaoSeller'
        }, {
            title: '直客昨日签单之星',
            route: 'zhikeYesterdayList',
            name: 'zhikeYesterdayList'
        }, {
            title: '渠道昨日签单之星',
            route: 'qudaoYesterdayList',
            name: 'qudaoYesterdayList'
        }, {
            title: '激励语和日期',
            route: 'SellDataTime',
            name: 'SellDataTime'
        }]
    }
];
export default NAV_DATA;


// WEBPACK FOOTER //
// ./src/config/route_mapping.js